// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userDocuments_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.userData_image {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}


.user_document_upload {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.user_documents_types_container {
    display: flex;
    flex-direction: column;
    gap: 50px
}

.user_document_type {
    margin: 0 0 20px 0;
    font-size: 19px;
    font-weight: bold;
}

.user_document_sumsub_type {
    font-size: 19px;
    font-weight: bold;
}

.user_file_upload {
    display: none;
}

.userData_documents_container {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.userData_documents {
    max-width: 200px;
}

.userData_doc_item {
    max-width: 200px;
    border-radius: 16px;
}

.user_doc_title {
    margin: 0 0 20px 0;
    font-size: 22px;
    font-weight: bold;
}

.userData_p {
    margin: 5px 0;
}




.userData_edition_input {
    width: 300px;
    border: 1px solid var(--border);
    border-radius: 5px;
    padding: 0px 10px;
    line-height: 1.5rem;
    font-size: medium;
}

.history_export_button {
    background-color: var(--primary);
    padding: 5px 20px;
    border-radius: 5px;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 15px;
    font-weight: bold;
    color: #fff;
}

.history_export_button:disabled {
    background-color: var(--primary-50);
}

.delete_document_button {
    color: var(--danger);
    font-weight: 700;
    font-size: 15px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: var(--radius-sm);
    transition: all var(--transition-fast);
    flex-shrink: 0;
}

.delete_non_image_box {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.agreement_download_button {
    background: none;
    border: none;
    padding: 0;
    color: inherit;
    font: inherit;
    text-decoration: underline;
    cursor: pointer;
}

.iban_document_embed {
    width: 200px;
    height: 260px;
    border: 1px solid var(--border);
    border-radius: 6px;
}

.iban_input {
    width: 320px;
    padding: 8px 12px;
    font-size: 15px;
    border: 1px solid var(--border);
    border-radius: 4px;
    background-color: var(--bg-card);
    color: var(--text-primary);
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserDocuments/userDocuments.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,4BAA4B;AAChC;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;;;;AAKA;IACI,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,aAAa;AACjB","sourcesContent":[".userDocuments_container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.userData_image {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n\n.user_document_upload {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.user_documents_types_container {\n    display: flex;\n    flex-direction: column;\n    gap: 50px\n}\n\n.user_document_type {\n    margin: 0 0 20px 0;\n    font-size: 19px;\n    font-weight: bold;\n}\n\n.user_document_sumsub_type {\n    font-size: 19px;\n    font-weight: bold;\n}\n\n.user_file_upload {\n    display: none;\n}\n\n.userData_documents_container {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.userData_documents {\n    max-width: 200px;\n}\n\n.userData_doc_item {\n    max-width: 200px;\n    border-radius: 16px;\n}\n\n.user_doc_title {\n    margin: 0 0 20px 0;\n    font-size: 22px;\n    font-weight: bold;\n}\n\n.userData_p {\n    margin: 5px 0;\n}\n\n\n\n\n.userData_edition_input {\n    width: 300px;\n    border: 1px solid var(--border);\n    border-radius: 5px;\n    padding: 0px 10px;\n    line-height: 1.5rem;\n    font-size: medium;\n}\n\n.history_export_button {\n    background-color: var(--primary);\n    padding: 5px 20px;\n    border-radius: 5px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: bold;\n    color: #fff;\n}\n\n.history_export_button:disabled {\n    background-color: var(--primary-50);\n}\n\n.delete_document_button {\n    color: var(--danger);\n    font-weight: 700;\n    font-size: 15px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: var(--radius-sm);\n    transition: all var(--transition-fast);\n    flex-shrink: 0;\n}\n\n.delete_non_image_box {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.agreement_download_button {\n    background: none;\n    border: none;\n    padding: 0;\n    color: inherit;\n    font: inherit;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.iban_document_embed {\n    width: 200px;\n    height: 260px;\n    border: 1px solid var(--border);\n    border-radius: 6px;\n}\n\n.iban_input {\n    width: 320px;\n    padding: 8px 12px;\n    font-size: 15px;\n    border: 1px solid var(--border);\n    border-radius: 4px;\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
